export const fixSeparators = (source: string): string => source.replace('.', '').replace(',', '.');
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const convertPercentToFactor = (source: number): number => source / 100;
export const convertDefault = (source: string): number => parseFloat(fixSeparators(source));
